import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getOrderTemplateConfig(params) {
  return request({
    url: URL.sys.getOrderTemplateConfig,
    method: 'get',
    params
  })
}

export function saveOrderTemplateConfig(data) {
  return request({
    url: URL.sys.saveOrderTemplateConfig,
    method: 'post',
    data
  })
}
export function getOrderTemplateFields(params) {
  return request({
    url: URL.sys.getOrderTemplateFields,
    method: 'get',
    params
  })
}
export function exportOrderTemplate(params) {
  return request({
    url: URL.sys.exportOrderTemplate,
    method: 'get',
    params
  })
}
